module.exports = __webpack_public_path__ + "static/media/welcomeBg_responsive.4db6f774.jpg";